import PlanActionsRow from './PlanActionsRow';
import React from 'react';

type PlanningCardProps = {
  selectedConnectionData: any;
  activeEvent: any;
  incomingProposals: any[];
  onPlanManual: () => void;
  onAutoplan: () => void;
  onProposal: () => void;
};

const PlanningCard: React.FC<PlanningCardProps> = ({
  selectedConnectionData,
  activeEvent,
  incomingProposals,
  onPlanManual,
  onAutoplan,
  onProposal,
}) => {
  const phase = selectedConnectionData?.phase ?? 'chat';
  const statusText = activeEvent
    ? 'Afspraak staat in agenda'
    : incomingProposals?.length > 0
    ? 'Voorstel klaar om te sturen'
    : 'Geen afspraak gepland';

  const label =
    phase === 'video'
      ? 'videogesprek'
      : phase === 'physical'
      ? 'ontmoeting'
      : 'belafspraak';

  return (
    <div className="mt-3 bg-white border border-gray-200 rounded-lg p-3 space-y-2">
      <div className="text-sm font-semibold text-gray-900">Plan je {label}</div>
      <div className="text-xs text-gray-600">{statusText}</div>
      <PlanActionsRow onPlanManual={onPlanManual} onAutoplan={onAutoplan} onProposal={onProposal} />
      <p className="text-xs text-gray-600">
        Kies een optie om je volgende {label} in te plannen.
      </p>
    </div>
  );
};

export default PlanningCard;

